import React from 'react'
import getRouteAndMatchDataRouteUtil from 'modules/routes/utils/get-route-and-match-data'
import getRouteAndMatchRouteUtil from 'modules/routes/utils/get-route-and-match'
import { logUtil } from 'packages/src'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import getLocationRouterSelect from 'modules/router/selectors/get-location'

const WithRouteAndMatch = Component => props => {
  props = props || {}
  const location = useSelector(getLocationRouterSelect)
  const routeAndMatch = getRouteAndMatchRouteUtil(location?.pathname)
  const newRouteAndMatch = getRouteAndMatchDataRouteUtil(routeAndMatch)
  const debugProps = {
    location,
    routeAndMatch,
    newRouteAndMatch
  }

  logUtil('WithRouteAndMatch').debug('debugProps=', debugProps)
  return (
    <Component
      {...props}
      location={location}
      {...newRouteAndMatch}
    />
  )
}

export default WithRouteAndMatch
